import { createGenericFormSlice, SliceState } from "./genericFormSlice";

interface SendGuestMessage {
  message: string | undefined;
}

const formSlice = createGenericFormSlice({
  name: "sendGuestMessage",
  initialState: {} as SliceState<SendGuestMessage>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const sendGuestMessageReducer = formSlice.reducer;
export default sendGuestMessageReducer;
